import { extractValidationMessage } from '../../../util/validationError';

/**
 * Kept as a named re-export: the envelope is commons-core's, not PMS-specific
 * (see util/validationError), but several call sites and tests import this name.
 */
export const extractPmsValidationMessage = extractValidationMessage;

const CREDENTIALS_REJECTED_MARKER = 'credentials were rejected';

export const REENABLE_CREDENTIALS_REJECTED_COPY =
  'Your stored credentials failed validation, so the integration remains disabled. Update them below and save to re-enable.';
export const STATUS_CHANGE_FORBIDDEN_COPY =
  "You don't have permission to change this integration.";

type StatusChangeAction = 'disable' | 'reenable';

const GENERIC_COPY: Record<StatusChangeAction, string> = {
  disable: "Couldn't disable the integration. Try again.",
  reenable: "Couldn't re-enable the integration. Try again.",
};

interface ErrorLike { status?: unknown }

const asErrorLike = (error: unknown): ErrorLike | null =>
  error !== null && typeof error === 'object' ? (error as ErrorLike) : null;

/** User-facing copy for a failed PUT …/pms/{entity}/status. */
export const describeStatusChangeError = (error: unknown, action: StatusChangeAction): string => {
  const status = asErrorLike(error)?.status;
  if (status === 401 || status === 403) return STATUS_CHANGE_FORBIDDEN_COPY;
  const parsed = extractPmsValidationMessage(error);
  if (parsed === null) return GENERIC_COPY[action];
  if (action === 'reenable' && parsed.includes(CREDENTIALS_REJECTED_MARKER)) {
    return REENABLE_CREDENTIALS_REJECTED_COPY;
  }
  return parsed;
};
